import {Component, EventEmitter, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CustomerInf} from '../../../interfaces/network/customer-inf';
import {LogicalConjunctionService} from "../../../services/common/logical-conjunction/logical-conjunction.service";
import * as _ from "lodash";

export interface CustomerDialogInf {
  items: [CustomerInf];
  selectedItem: CustomerInf;
  isEditMode?: boolean;
  cacProfiles: any;
  prefixGroups: any;
}

@Component({
  selector: 'customers-dialog',
  templateUrl: './customers-dialog.component.html',
  styleUrls: ['./customers-dialog.component.scss']
})
export class CustomersDialogComponent implements OnInit {

  prefixGroupDirty = false;
  constructor(public dialogRef: MatDialogRef<CustomersDialogComponent>,
              private logicalConjunctionService: LogicalConjunctionService,
              @Inject(MAT_DIALOG_DATA) public data: CustomerDialogInf) { }

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  logicalConjunctionNotice: string;


  sipHeaderOptions = [{
    value: 'CONTACT_HOST',
    text: 'CONTACT_HOST'
  }];

  ngOnInit(): void {
    this.data.selectedItem.sipHeaderName = 'CONTACT_HOST';
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.onApply.emit(this.data);
  }

  isElementSelected(): boolean {
    return this.data.selectedItem.attributeGroups
      && this.data.selectedItem.attributeGroups.length === 0;
  }

  setPrefixGroupDirty(): void {
    this.prefixGroupDirty = true;
  }

  isAttrGroupEmpty(): boolean {
    return !this.data.selectedItem.attributeGroups || (this.data.selectedItem.attributeGroups && this.data.selectedItem.attributeGroups.length === 0);
  }

  updateLogicalConjunctionNotice(): void {
    const andItems = [];
    const target = 'customer';

    if (!_.isEmpty(this.data.selectedItem.attributeGroups)) { andItems.push('defined Prefix Group'); }
    if (!_.isEmpty(this.data.selectedItem.tag)) { andItems.push('defined Policy Studio Tag'); }



    this.logicalConjunctionNotice = this.logicalConjunctionService.generateNoticeMessage(andItems, [], target);
  }

}
